import { ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA, DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA }
from '../../actions/types';

const initialState = undefined;

export const paginaAtualSelecaoEmpresa = (state = 1, action = initialState) => {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA: {
      return action.payload;
    }

    default:
      return state;
  }
};

export const registrosPorPaginaSelecaoEmpresa = (state = 12, action = initialState) => {
  switch (action.type) {
    case ALTERAR_NUMERO_REGISTROS_POR_PAGINA_SELECAO_EMPRESA: {
      return action.payload;
    }

    default:
      return state;
  }
};
